// extracted by mini-css-extract-plugin
export default {"container":"MissingAccess_container__X5gQ7","info-container":"MissingAccess_info-container__pRJc1","heading":"MissingAccess_heading__4IFjN"};